/* ICExtract product page — vanilla, no dependencies.
   Variant resolution, gallery (thumbs/swipe/zoom/keyboard), accordions,
   quantity, add-to-cart (AJAX), and sticky ATC coordination. */
(function () {
  'use strict';

  // Run-once guard: this script may be injected by multiple sections
  // (main-product, product-details, commercial-faq) on the same page.
  // Binding more than once would double-submit the add-to-cart form.
  if (window.__icProductInit) return;
  window.__icProductInit = true;

  var money = function (cents) {
    // Uses Shopify money format when available; fallback to plain.
    if (window.Shopify && window.Shopify.formatMoney && window.icMoneyFormat) {
      return window.Shopify.formatMoney(cents, window.icMoneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  };

  var strings = window.icStrings || {};

  /* ================= Accordions (all templates) =================
     Bound document-wide and idempotently, because product-details and
     commercial-faq render accordions even when no main product section
     is present (e.g. apex-commercial). */
  Array.prototype.forEach.call(document.querySelectorAll('[data-ic-accordion-trigger]'), function (trigger) {
    if (trigger.hasAttribute('data-ic-bound')) return;
    trigger.setAttribute('data-ic-bound', '');
    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      var panelId = trigger.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (panel) panel.hidden = expanded;
    });
  });

  /* ================= Quantity steppers (main / non-sticky) =================
     The sticky bar has its own quantity handling in ic-sticky-atc.js, so
     wrappers inside [data-ic-sticky-atc] are skipped here to avoid binding
     the same +/- buttons twice. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-ic-quantity]'), function (wrap) {
    if (wrap.hasAttribute('data-ic-bound')) return;
    if (wrap.closest('[data-ic-sticky-atc]')) return;
    wrap.setAttribute('data-ic-bound', '');
    var input = wrap.querySelector('[data-ic-qty-input]');
    if (!input) return;
    var down = wrap.querySelector('[data-ic-qty-down]');
    var up = wrap.querySelector('[data-ic-qty-up]');
    if (down) down.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) { input.value = v - 1; input.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    if (up) up.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1; input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ================= Main product buy logic =================
     Only runs when the main product section is on the page. */
  var section = document.querySelector('[data-ic-product-main]');
  if (!section) return;

  /* ---------------- Variant picker ---------------- */
  var picker = section.querySelector('[data-ic-variant-picker]');
  var variants = [];
  if (picker) {
    var dataEl = picker.querySelector('[data-ic-variant-data]');
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    }
  }

  var selectedInput = section.querySelector('[data-ic-selected-variant]');
  var priceEl = section.querySelector('[data-ic-price]');
  var compareWrap = section.querySelector('[data-ic-compare]');
  var compareVal = section.querySelector('[data-ic-compare-value]');
  var saleBadge = section.querySelector('[data-ic-sale-badge]');
  var skuEl = section.querySelector('[data-ic-sku]');
  var addBtn = section.querySelector('[data-ic-add-btn]');
  var addText = section.querySelector('[data-ic-add-text]');
  var inventoryEl = section.querySelector('[data-ic-inventory]');
  var inventoryLabel = section.querySelector('[data-ic-inventory-label]');

  function selectedOptions() {
    var opts = [];
    if (!picker) return opts;
    var wrappers = picker.querySelectorAll('[data-ic-option-wrapper]');
    Array.prototype.forEach.call(wrappers, function (w) {
      var checked = w.querySelector('[data-ic-option-input]:checked');
      var select = w.querySelector('[data-ic-option-select]');
      if (checked) opts.push(checked.value);
      else if (select) opts.push(select.value);
    });
    return opts;
  }

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < opts.length; j++) {
        if (v.options[j] !== opts[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function updateOptionLabels(opts) {
    if (!picker) return;
    var wrappers = picker.querySelectorAll('[data-ic-option-wrapper]');
    Array.prototype.forEach.call(wrappers, function (w, idx) {
      var label = w.querySelector('[data-ic-option-label="' + (idx + 1) + '"]');
      if (label && opts[idx] != null) label.textContent = opts[idx];
    });
  }

  function onVariantChange() {
    var opts = selectedOptions();
    updateOptionLabels(opts);
    var variant = findVariant(opts);

    if (!variant) {
      if (addBtn) { addBtn.disabled = true; }
      if (addText) { addText.textContent = strings.unavailable || 'Unavailable'; }
      return;
    }

    if (selectedInput) selectedInput.value = variant.id;

    // URL deep-link
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}

    // Price
    if (priceEl) priceEl.textContent = money(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (compareVal) compareVal.textContent = money(variant.compare_at_price);
      if (compareWrap) compareWrap.hidden = false;
      if (saleBadge) saleBadge.hidden = false;
      if (priceEl) priceEl.classList.add('ic-price__sale');
    } else {
      if (compareWrap) compareWrap.hidden = true;
      if (saleBadge) saleBadge.hidden = true;
      if (priceEl) priceEl.classList.remove('ic-price__sale');
    }

    // SKU
    if (skuEl) skuEl.textContent = variant.sku || '';

    // Availability
    if (addBtn && addText) {
      if (variant.available) {
        addBtn.disabled = false;
        addText.textContent = strings.addToCart || 'Add to cart';
      } else {
        addBtn.disabled = true;
        addText.textContent = strings.soldOut || 'Sold out';
      }
    }

    // Media
    if (variant.featured_media_id) selectMedia(variant.featured_media_id);

    // Inventory dot
    updateInventory(variant);

    // Broadcast for sticky ATC
    document.dispatchEvent(new CustomEvent('ic:variant:change', { detail: { variant: variant } }));
  }

  function updateInventory(variant) {
    if (!inventoryEl) return;
    inventoryEl.classList.remove('ic-inventory--in', 'ic-inventory--low', 'ic-inventory--out');
    var state = 'out';
    var label = strings.outOfStock || 'Out of stock';
    if (variant.available) {
      if (!variant.inventory_management || variant.inventory_policy === 'continue') {
        state = 'in'; label = strings.inStock || 'In stock';
      } else if (variant.inventory_quantity > 0 && variant.inventory_quantity <= (window.icLowStock || 10)) {
        state = 'low';
        label = (strings.lowStockCount || 'Only {{ count }} left').replace('{{ count }}', variant.inventory_quantity);
      } else {
        state = 'in'; label = strings.inStock || 'In stock';
      }
    }
    inventoryEl.classList.add('ic-inventory--' + state);
    if (inventoryLabel) inventoryLabel.textContent = label;
  }

  if (picker) {
    picker.addEventListener('change', function (e) {
      if (e.target.matches('[data-ic-option-input], [data-ic-option-select]')) onVariantChange();
    });
  }

  /* ---------------- Gallery ---------------- */
  var gallery = section.querySelector('[data-ic-gallery]');
  var viewport = section.querySelector('[data-ic-gallery-viewport]');

  function selectMedia(mediaId) {
    if (!gallery) return;
    var slide = gallery.querySelector('[data-ic-gallery-slide][data-media-id="' + mediaId + '"]');
    if (slide && viewport) {
      viewport.scrollTo({ left: slide.offsetLeft - viewport.offsetLeft, behavior: 'smooth' });
    }
    Array.prototype.forEach.call(gallery.querySelectorAll('[data-ic-gallery-thumb]'), function (t) {
      var active = t.getAttribute('data-media-id') === String(mediaId);
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  if (gallery) {
    Array.prototype.forEach.call(gallery.querySelectorAll('[data-ic-gallery-thumb]'), function (thumb) {
      thumb.addEventListener('click', function () {
        selectMedia(thumb.getAttribute('data-media-id'));
      });
    });
    // Keyboard nav on viewport
    if (viewport) {
      viewport.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var thumbs = gallery.querySelectorAll('[data-ic-gallery-thumb]');
        if (!thumbs.length) return;
        var activeIdx = 0;
        Array.prototype.forEach.call(thumbs, function (t, i) { if (t.classList.contains('is-active')) activeIdx = i; });
        var next = e.key === 'ArrowRight' ? activeIdx + 1 : activeIdx - 1;
        if (next < 0) next = thumbs.length - 1;
        if (next >= thumbs.length) next = 0;
        selectMedia(thumbs[next].getAttribute('data-media-id'));
        e.preventDefault();
      });
    }
  }

  /* ---------------- Lightbox ---------------- */
  var lightbox = section.querySelector('[data-ic-lightbox]');
  var lightboxImg = section.querySelector('[data-ic-lightbox-img]');
  var lightboxClose = section.querySelector('[data-ic-lightbox-close]');
  var lightboxReturn = null;

  function openLightbox(src, alt) {
    if (!lightbox) return;
    lightboxReturn = document.activeElement;
    lightboxImg.src = src;
    lightboxImg.alt = alt || '';
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    lightboxClose.focus();
    document.addEventListener('keydown', lightboxKey);
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', lightboxKey);
    if (lightboxReturn) lightboxReturn.focus();
  }
  function lightboxKey(e) { if (e.key === 'Escape') closeLightbox(); }

  if (gallery && lightbox) {
    Array.prototype.forEach.call(gallery.querySelectorAll('[data-ic-gallery-zoom]'), function (btn) {
      btn.addEventListener('click', function () {
        openLightbox(btn.getAttribute('data-full'), btn.getAttribute('data-alt'));
      });
    });
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
  }

  /* ---------------- Add to cart (AJAX) ---------------- */
  var form = document.getElementById('IcProductForm-' + section.getAttribute('data-section-id'));
  var feedback = section.querySelector('[data-ic-buy-feedback]');

  function addToCart(theForm, btn, msgEl) {
    var formData = new FormData(theForm);
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
        if (!res.ok) {
          if (msgEl) { msgEl.textContent = (res.data && res.data.description) || strings.addError || 'Could not add to cart'; msgEl.className = 'ic-buy__feedback ic-buy__feedback--error'; }
          return;
        }
        if (msgEl) { msgEl.textContent = strings.added || 'Added to cart'; msgEl.className = 'ic-buy__feedback ic-buy__feedback--success'; }
        document.dispatchEvent(new CustomEvent('ic:cart:added', { detail: { item: res.data } }));
      })
      .catch(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
        if (msgEl) { msgEl.textContent = strings.addError || 'Could not add to cart'; msgEl.className = 'ic-buy__feedback ic-buy__feedback--error'; }
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(form, addBtn, feedback);
    });
  }
  // expose for sticky ATC
  window.icAddToCart = addToCart;

  // Initialize from any preselected variant
  if (picker && variants.length) onVariantChange();
})();
